!function () {
    const _pluralize = (n, titles, noNumber) => `${noNumber ? '' : n + ' '}${(typeof titles === 'string' ? titles.split('|') : titles)[n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2]}`;
    app.pluralize = _pluralize;
    app.textPluralize = (n, titles) => _pluralize(n, titles, true);
}();

app.isInViewport = ($element, options = {edge: 'all', offset: 0}) => {
    const element = (($element instanceof jQuery) ? $element[0] : $element);
    const rect = element.getBoundingClientRect();
    if ( options.edge == 'top' ) {
        return rect.top >= window.innerHeight || rect.top < 0;
    }
    return (rect.top > 0 ? rect.top + element.offsetHeight + document.documentElement.scrollTop <= window.innerHeight + document.documentElement.scrollTop : rect.top + document.documentElement.scrollTop >= window.innerHeight + document.documentElement.scrollTop);
}

app.prettyPrice = (price, symbol = ' ₽') => `${ price.toString().replace(/\./g, ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ') }${symbol ? symbol : ''}`;

app.getMonthlyPaymentAmount = getMonthlyPaymentAmount;

/**
 * getMonthlyPaymentAmount
 * @param interestRate - годовая процентная ставка
 * @param cost - сумма кредита
 * @param termInYears - срок
 * @param amountPaymentStart? - Сумма первоначального взноса
 * @return number as Сумма ежемесячного платежа
 */
function getMonthlyPaymentAmount({ interestRate, cost, termInYears, amountPaymentStart = 0 }) {
    /* Процентная ставка по кредиту в месяц */
    const interestRateMonth = interestRate / 100 / 12;
    const termInMonths = termInYears * 12;

    /* Коэффициент аннуитета */
    const annuityRatio = (interestRateMonth * Math.pow((1 + interestRateMonth), termInMonths)) / (Math.pow((1 + interestRateMonth), termInMonths) - 1);

    return annuityRatio * (cost - amountPaymentStart);
}
